import sendRequest from "@/libs/sendRequest";

export const historialMonitoreo = {
    namespaced: true,

    state: () => ({
        data: [],
        total_data: 0,
        loading: false,
        error: null,
        rutas: [],
        rutasLoading: false,
        rutasError: null,
        detalle: null,
        detalleLoading: false,
        detalleError: null
    }),
    
    getters: {
        getItems: (state) => state.data.list || { result: [], total_rows: 0 },
        getTotal: (state) => state.total_data,
        isLoading: (state) => state.loading,
        getError: (state) => state.error,
        getRutas: (state) => state.rutas,
        isRutasLoading: (state) => state.rutasLoading,
        getRutasError: (state) => state.rutasError,
        getDetalle: (state) => state.detalle,    
        isDetalleLoading: (state) => state.detalleLoading,
        getDetalleError: (state) => state.detalleError
    },
    
    mutations: {
        setItems(state, payload) {
            state.data = payload;
        },
        setTotalItems(state, payload) {
            state.total_data = payload;
        },
        setLoading(state, payload) {
            state.loading = payload;
        },
        setError(state, payload) {
            state.error = payload;
        },
        setRutas(state, payload) {
            state.rutas = payload;
        },
        setRutasLoading(state, payload) {
            state.rutasLoading = payload;
        },
        setRutasError(state, payload) {
            state.rutasError = payload;
        },
        setDetalle(state, payload) {      
            state.detalle = payload;
        },
        setDetalleLoading(state, payload) {
            state.detalleLoading = payload;
        },
        setDetalleError(state, payload) {
            state.detalleError = payload;
        },
        clearDetalle(state) {          
            state.detalle = null;
            state.detalleError = null;
        },
        setSending(state, payload) {
            state.loading = payload; 
          }
    },
    
    actions: {
        async list({ commit, rootGetters }, { 
            page = 1, 
            rows = 10, 
            search = '', 
            order_by = 'Id', 
            order_asc = false,
            ruta = '',
            heishop_module = '' 
        }) {
            commit('setLoading', true);
            commit('setError', null);
            
            try {
                const custom_headers = rootGetters['getHeaders'];
                
                const params = new URLSearchParams({
                    isDatatable: true,
                    page,
                    rows,
                    search,
                    order_by,
                    order_asc: order_asc ? 'true' : 'false',
                    ...(ruta && { ruta }),
                    ...(heishop_module && { heishop_module })
                });

                const response = await sendRequest(
                    `administrator/heishop/monitoring/history?${params.toString()}`,
                    'GET',
                    null,
                    null,
                    null,
                    custom_headers
                );

                if (response.data) {
                    commit('setItems', response.data);
                    commit('setTotalItems', response.data.list?.total_rows || 0);
                } else {
                    commit('setError', response.errors || 'Error al cargar los datos');
                }
                
                return response.data;
            } catch (error) {
                commit('setError', error.message || 'Error en la solicitud');
                throw error;
            } finally {
                commit('setLoading', false);
            }
        },

        async fetchRutas({ commit, rootGetters }, prefix = 'P') {
            commit('setRutasLoading', true);
            commit('setRutasError', null);
            
            try {
                const custom_headers = rootGetters['getHeaders'];
                
                const response = await sendRequest(
                    `administrator/heishop/rutas?prefix=${prefix}`,
                    'GET',
                    null,
                    null,
                    null,
                    custom_headers
                );

                if (response.data) {
                    commit('setRutas', response.data.rutas || []);
                } else {
                    commit('setRutasError', 'Error al cargar las rutas');
                }
                
                return response.data?.rutas || [];
            } catch (error) {
                commit('setRutasError', error.message || 'Error al cargar las rutas');
                throw error;
            } finally {
                commit('setRutasLoading', false);
            }
        },

        async fetchDetalle({ commit, rootGetters }, id) {
            commit('setDetalleLoading', true);
            commit('clearDetalle');
            
            try {
                const custom_headers = rootGetters['getHeaders'];
                
                const response = await sendRequest(
                    `administrator/heishop/monitoring/view?Id=${id}`,
                    'GET',
                    null,
                    null,
                    null,
                    custom_headers
                );

                if (response.data.view) {
                    commit('setDetalle', response.data.view);
                } else {
                    commit('setDetalleError', response.errors || 'Error al cargar el detalle');
                }
                
                return response.data.view;
            } catch (error) {
                commit('setDetalleError', error.message || 'Error al cargar el detalle');
                throw error;
            } finally {
                commit('setDetalleLoading', false);
            }
        },

        
        async sendItem({ commit, dispatch, rootGetters }, { id, endpoint, module }) {
            commit('setLoading', true);
            commit('setError', null);
            
            try {
                const custom_headers = rootGetters['getHeaders'];
        
                const url = `${endpoint}?id_monitoring=${id}&module=${module}`;
        
                const response = await sendRequest(
                    url,
                    'POST',
                    null,
                    null,
                    null,
                    custom_headers
                );
        
                if (response.data) {
                    dispatch('showAlert', `Datos del módulo ${module} enviados correctamente`, { root: true });
                    return response.data;
                } else {
                    commit('setError', 'Un error ha ocurrido, intente más tarde');
                }
        
            } catch (error) {
                commit('setError', error.message || 'Error en la solicitud');
                alert(`Error: ${error.message || 'Error al enviar los datos'}`);
                throw error;
            } finally {
                commit('setLoading', false);
            }
        }
        
        
        
        
    }
};